import React, { useState, useEffect } from "react";
import { MousePointerClick, Eye, TrendingUp, Hash } from "lucide-react";

export default function Dashboard() {
  const [data, setData] = useState({ loading: true });
  const [timeRange, setTimeRange] = useState("7days");

  useEffect(() => {
    // Mock data - Google Search Console API entegrasyonu için yer tutucu
    const timer = setTimeout(() => {
      setData({
        totalClicks: 12543,
        totalImpressions: 456789,
        avgCTR: 2.75,
        avgPosition: 8.4,
        loading: false,
      });
    }, 800);
    return () => clearTimeout(timer);
  }, [timeRange]);

  const stats = [
    {
      title: "Toplam Tıklama",
      value: data.totalClicks?.toLocaleString("tr-TR") || "0",
      icon: MousePointerClick,
      color: "#6366f1",
      bg: "#eef2ff",
    },
    {
      title: "Toplam Gösterim",
      value: data.totalImpressions?.toLocaleString("tr-TR") || "0",
      icon: Eye,
      color: "#06b6d4",
      bg: "#ecfeff",
    },
    {
      title: "Ortalama CTR",
      value: `%${data.avgCTR || 0}`,
      icon: TrendingUp,
      color: "#10b981",
      bg: "#ecfdf5",
    },
    {
      title: "Ortalama Pozisyon",
      value: data.avgPosition || "0",
      icon: Hash,
      color: "#f59e0b",
      bg: "#fffbeb",
    },
  ];

  const topPages = [
    { url: "/hizmetler/web-tasarim", clicks: 3240, impressions: 45600, ctr: "7.1%", position: 3.2 },
    { url: "/hizmetler/seo-optimizasyonu", clicks: 2890, impressions: 38900, ctr: "7.4%", position: 4.1 },
    { url: "/blog/react-rehberi", clicks: 1560, impressions: 28700, ctr: "5.4%", position: 6.8 },
    { url: "/hakkimizda", clicks: 1230, impressions: 19800, ctr: "6.2%", position: 5.3 },
    { url: "/iletisim", clicks: 890, impressions: 15400, ctr: "5.8%", position: 7.1 },
  ];

  if (data.loading) {
    return (
      <div className="page-loading">
        <div className="loading-spinner" />
        <p>Veriler yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="page-header">
        <div>
          <h2>Dashboard</h2>
          <p className="page-subtitle">Sitenizin performans özeti</p>
        </div>
        <div className="header-actions">
          <select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            className="form-select"
          >
            <option value="7days">Son 7 Gün</option>
            <option value="28days">Son 28 Gün</option>
            <option value="3months">Son 3 Ay</option>
          </select>
        </div>
      </div>

      <div className="stats-grid">
        {stats.map((stat, i) => {
          const Icon = stat.icon;
          return (
            <div key={i} className="stat-card">
              <div className="stat-icon" style={{ background: stat.bg, color: stat.color }}>
                <Icon size={24} />
              </div>
              <div className="stat-info">
                <span className="stat-label">{stat.title}</span>
                <span className="stat-value">{stat.value}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="dashboard-table-card">
        <div className="card-header-row">
          <h3>En Çok Ziyaret Edilen Sayfalar</h3>
        </div>
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Sayfa</th>
                <th>Tıklama</th>
                <th>Gösterim</th>
                <th>CTR</th>
                <th>Pozisyon</th>
              </tr>
            </thead>
            <tbody>
              {topPages.map((page, i) => (
                <tr key={i}>
                  <td className="page-url">{page.url}</td>
                  <td>{page.clicks.toLocaleString("tr-TR")}</td>
                  <td>{page.impressions.toLocaleString("tr-TR")}</td>
                  <td><span className="badge badge-success">{page.ctr}</span></td>
                  <td>{page.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
